import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import H2 from 'UIComponents/elements/headings/H2';
import UIIllustration from 'UIComponents/image/UIIllustration';
import TrackRender from 'growth-payments-core/usage-tracker/TrackRender';
import { events } from 'growth-payments-core/usage-tracker/events';
import { TrackedLoadingButton } from 'growth-payments-core/usage-tracker/components/Button';
import { useCleanupScopedLocalStorage } from 'growth-payments-core/localStorage/useLocalStorageState';
import { useEffect } from 'react';
import { Metrics } from '../../utils/metrics';
import { useFallbackModalRedirect } from '../../hooks/modalProps';
import { useIsUngatedForKycEmbeddedFallbackExperience } from 'growth-payments-core/auth/gates';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  KYC_FALLBACK_MODAL_VERIFY: 'kyc-fallback-modal-verify',
  KYC_FALLBACK_MODAL: 'kyc-fallback-modal'
};
const StripeApplicationFallbackModal = ({
  businessTypeDetails,
  onClose
}) => {
  const {
    businessType,
    businessStructure
  } = businessTypeDetails;
  const {
    redirect,
    isButtonError,
    isButtonLoading
  } = useFallbackModalRedirect({
    businessType,
    businessStructure
  });
  const isUngatedForKycEmbeddedFallbackExperience = useIsUngatedForKycEmbeddedFallbackExperience();
  const cleanupScopedLocalStorage = useCleanupScopedLocalStorage(['kyc-step-stack', 'hs-payments-kyc']);
  const handleClick = () => {
    cleanupScopedLocalStorage();
    if (isUngatedForKycEmbeddedFallbackExperience) {
      onClose();
    } else {
      redirect();
    }
  };
  useEffect(() => {
    if (businessType) {
      Metrics.counter('stripe-fallback-modal-viewed', {
        businessType,
        businessStructure: businessStructure || ''
      }).increment();
    }
  }, [businessStructure, businessType]);
  return /*#__PURE__*/_jsxs(UIModal, {
    centered: true,
    use: "info",
    width: 500,
    "data-test-id": TEST_IDS.KYC_FALLBACK_MODAL,
    children: [/*#__PURE__*/_jsx(TrackRender, {
      event: events.growthPaymentsPageView,
      properties: {
        screen: 'stripe-application-fallback-modal'
      }
    }), /*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetBottom: -30,
      offsetTop: 59,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        alt: I18n.text('altText.trafficCone'),
        name: "cone",
        width: 118
      })
    }), /*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "stripeSubmissionFallbackModal.header"
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      style: {
        textAlign: 'left'
      },
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "300",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "stripeSubmissionFallbackModal.body1"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "stripeSubmissionFallbackModal.body2"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(TrackedLoadingButton, {
        event: events.paymentSettingsInteraction,
        trackingProperties: {
          action: 'stripeApplicationFallbackRedirectButtonClicked'
        },
        "data-test-id": TEST_IDS.KYC_FALLBACK_MODAL_VERIFY,
        use: "primary",
        loading: isButtonLoading,
        failed: isButtonError,
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "stripeSubmissionFallbackModal.primaryCta"
        })
      })
    })]
  });
};
export default StripeApplicationFallbackModal;